export default "__VITE_ASSET__9dc42084__"